import { Component, OnInit } from '@angular/core';
import { InboxService } from '../../../../../services/inbox/inbox.service';

@Component({
  selector: 'app-inbox-customers',
  templateUrl: './inbox-customers.component.html',
  styleUrls: ['./inbox-customers.component.css']
})
export class InboxCustomersComponent implements OnInit {

  constructor(
    public inboxService: InboxService
  ) {}

  ngOnInit() {
  }

}
